/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Many_House_Horse_LaunchInputs */

const fr_many_house_horse_launch = /** @type {(inputs: Many_House_Horse_LaunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

/**

* @param {Many_House_Horse_LaunchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const many_house_horse_launch = /** @type {((inputs?: Many_House_Horse_LaunchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Many_House_Horse_LaunchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_many_house_horse_launch(inputs)
});